import 'prismjs/components/prism-python';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-yaml';

// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import Prism from 'prismjs';
import React, {useLayoutEffect, useRef, useState} from 'react';

import {CodeCopyButton} from './CodeCopyButton';
import * as S from './CodeSnippet.styles';

type CodeSnippetProps = {
  showExpandCollapse?: boolean;
  codeSnippet: string;
  analyticsEvent?: (data: any) => void;
  analyticsDefaultProperties?: Record<string, any>;
  backgroundColor?: string;
  codeLanguage?: string;
};

export const CodeSnippet = ({
  showExpandCollapse,
  codeSnippet,
  analyticsEvent,
  analyticsDefaultProperties,
  backgroundColor,
  codeLanguage = 'python',
}: CodeSnippetProps) => {
  const [isExpanded, setIsExpanded] = useState(
    showExpandCollapse === false ? true : false
  );
  const [isHovering, setIsHovering] = useState(false);

  const codeRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (codeRef.current != null) {
      Prism.highlightElement(codeRef.current);
    }
  }, [codeSnippet]);

  return (
    <S.CodeSnippetContainer
      $isExpanded={isExpanded || !showExpandCollapse}
      $backgroundColor={backgroundColor}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}>
      {isHovering && (
        <CodeCopyButton
          copyContent={codeSnippet}
          analyticsEvent={analyticsEvent}
          analyticsDefaultProperties={analyticsDefaultProperties}
        />
      )}
      <S.CodeSnippet $isExpanded={isExpanded || !showExpandCollapse}>
        <S.PrismCodeHighlighting
          ref={codeRef}
          className={`language-${codeLanguage}`}>
          {codeSnippet}
        </S.PrismCodeHighlighting>
      </S.CodeSnippet>
      {showExpandCollapse && (
        <S.CodeSnippetExpandCollapse onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? (
            <S.IconContainer>
              Show less
              <Icon name="chevron-up" />
            </S.IconContainer>
          ) : (
            <S.IconContainer>
              Show more <Icon name="chevron-down" />
            </S.IconContainer>
          )}
        </S.CodeSnippetExpandCollapse>
      )}
    </S.CodeSnippetContainer>
  );
};
